import { el, setAttr } from 'redom';
import { resolveToPixels } from './utilities';

class TextArea {

  constructor(configuration) {

    this.disabled = configuration.disabled;
    this.value = configuration.value || '';

    this.onChange = configuration.onChange || function noop() {};
    this.onEnterKey = configuration.onEnterKey;
    this.onEscapeKey = configuration.onEscapeKey;
    this.autoHeight = configuration.autoHeight;

    if (typeof this.autoHeight === 'string' && this.autoHeight !== '') {
      this.resolvedAutoHeight = resolveToPixels(this.autoHeight);
    }

    this.el = el('textarea', {
      disabled: this.disabled,
      id: configuration.id || performance.timeOrigin + performance.now(),
      class: 'form-field textarea-input hide-scrollbar ' + (configuration.class || ''),
      value: this.value,
      placeholder: configuration.placeholder || '',
      onkeydown: this.handleInputChange.bind(this),
      oninput: this.handleInputChange.bind(this),
      onfocus: this.handleFocus.bind(this),
      onblur: this.handleBlur.bind(this),
      onpaste(event) {
        event.stopPropagation();
      }
    });

  }

  handleInputChange(event) {

    const previousValue = this.previousValue;
    const currentValue = event.target.value;

    if (event.key === 'Enter') {

      if (typeof this.onEnterKey === 'function') {
        this.onEnterKey(this.value);
        return;
      }

    } else if (event.key === 'Escape') {

      if (typeof this.onEscapeKey === 'function') {
        this.onEscapeKey(this.value);
        return;
      }

    }

    if (previousValue === currentValue) {
      return;
    }

    this.previousValue = currentValue;

    this.value = currentValue;

    this.onChange(event, currentValue);

    this.adjustAutoHeight();

  }

  adjustAutoHeight() {

    if (this.resolvedAutoHeight == null) {
      return;
    }

    this.el.style.minHeight = '0';
    this.el.style.height = 'auto';
    const contentHeight = this.el.scrollHeight;

    if (contentHeight >= this.resolvedAutoHeight) {
      this.el.style.height = this.resolvedAutoHeight + 'px';
      this.el.scrollTop = this.el.scrollHeight;
      return;
    }

    this.el.style.height = contentHeight + 'px';

  }

  handleFocus() {

    if (this.resolvedAutoHeight == null) {
      return;
    }

    this.el.style.minHeight = '0';
    const contentHeight = this.el.scrollHeight;

    let targetHeight = this.resolvedAutoHeight;

    if (contentHeight < this.resolvedAutoHeight) {
      targetHeight = contentHeight;
    }

    this.el.style.minHeight = targetHeight + 'px';

  }

  handleBlur() {

    if (this.resolvedAutoHeight == null) {
      return;
    }

    this.el.style.minHeight = '';
    this.el.style.height = '';

  }

  setReadOnly(readOnly) {

    setAttr(this.el, { disabled: readOnly });

  }

  setValue(value) {

    this.value = value;

    this.el.value = value;

  }

  focus() {

    this.el.focus();

  }

  getValue() {

    return this.value;

  }

  setAttr(attributes) {

    setAttr(this.el, attributes);

  }

}

export default TextArea;
